
import { useCallback } from 'react';
import { Task } from '@/context/TaskContext';

const quadrants = [
  { id: 'do-first', label: 'Do First', icon: '🔥' },
  { id: 'schedule', label: 'Schedule', icon: '🧠' },
  { id: 'delegate', label: 'Delegate', icon: '🤝' },
  { id: 'eliminate', label: 'Eliminate', icon: '🗑️' },
];

export type QuadrantMap = { [key: string]: Task[] };

export function useQuadrantTasks(tasks: Task[]) {
  // Split tasks by quadrant and sort by priority_y (used as "position in quadrant")
  const getQuadrantTasks = useCallback((): QuadrantMap => {
    const map: QuadrantMap = {};
    for (const q of quadrants) {
      map[q.id] = tasks
        .filter(t => t.priority_quadrant === q.id)
        .sort((a, b) => (a.priority_y ?? 0) - (b.priority_y ?? 0));
    }
    return map;
  }, [tasks]);

  const quadrantTasks = getQuadrantTasks();
  const unprioritizedTasks = tasks.filter(t => !t.priority_quadrant);

  return {quadrantTasks, unprioritizedTasks, quadrants};
}
